import { versioneInSituStore } from '../VersioneInSitu/store/VersioneInSitu.store';
import moment from 'moment';
import { printerHelper } from '../printer';
import { areaRaccoltaStore } from '../AreaRaccolta/store/areaRaccolta.store';
import { areaSaggioClasseDiametricaStore } from '../AreaSaggioClasseDiametrica/store/areaSaggioClasseDiametrica.store';
import { areaSaggioPiantaCampioneStore } from '../AreaSaggioPiantaCampione/store/areaSaggioPiantaCampione.store';
import { domainStore } from '../domains';
import { usersStore } from '../Utenti/store/users.store';

export async function exportForm(source: server.areaSaggio, type: printer.type = printer.type.pdf): Promise<void> {
    let utenteCreatore = ["-- nessun creatore --"];
    let utentiRilevatori: string[] = ["-- nessun rilevatore --"];
    const users = await usersStore.getters.getAll();

    if (source.userId) {
        const user = users.find(f => f.id.toLowerCase() === source.userId.toLowerCase());
        if (user) utenteCreatore = [`${user.firstName} ${user.lastName}`];
    }

    if ((source.utentiRilevatori || []).length > 0) {
        utentiRilevatori = users.filter(f => source.utentiRilevatori.map(m => m.toLowerCase()).indexOf(f.id.toLowerCase()) !== -1)
            .map((m) => `${m.firstName} ${m.lastName}`)
            .sort((a, b) => a.localeCompare(b));
    }

    const printObj = [
        {
            header: "Dati Generali",
            data: {
                'Anno censimento': (await versioneInSituStore.getters.get(source.versioneId)).alias,
                'Denominazione Area': source.nome ? source.nome : '',
                'Area Raccolta Relazionata': (await areaRaccoltaStore.getters.get(source.areaRaccoltaId)).nome,
                'Raggio Area di Saggio': source.raggio || source.raggio==0 ? source.raggio.toFixed(1) + ' m' : '',
                'Superficie Area': source.area || source.area==0 ? source.area.toFixed(1) + ' m2' : '',
                'Specie Presenti': source.speciePresenti != null && source.speciePresenti.length > 0 ? (await domainStore.getters.specieArboree()).filter((f) => source.speciePresenti.includes(f.id)).map((m) => m?.label).join(", ") : '',
            }
        }, {
            header: "Altro",
            data: {
                'Note': source.note ? source.note : null,
                'Data rilievo': source.data ? moment(source.data).format("DD-MM-YYYY") : '',
                'Utente creatore dell\'area': utenteCreatore,
                'Rilevatori in campo': utentiRilevatori
            }
        }
    ] as printer.group[];

    const specieArboree = await domainStore.getters.specieArboree();

    const classiDiametriche = (await areaSaggioClasseDiametricaStore.getters.getAll()).filter(f => f.areaSaggioId === source.id);
    if (classiDiametriche && classiDiametriche.length > 0) {
        const classiDiametricheReduceByDiametroAndSpecie = classiDiametriche.sort((a, b) => a.diametro - b.diametro).reduce((acc, curr) => {
            const key = `${curr.specie}---${curr.diametro}`;
            if (!acc[key]) {
                acc[key] = {
                    diametro: curr.diametro,
                    specie: curr.specie,
                    contatore: 0,
                } as { specie: number, contatore: number }
            }
            acc[key].contatore += curr.contatore;
            return acc;
        }, {});

        const classiDiametricheReduceByDiametro = (Object.values(classiDiametricheReduceByDiametroAndSpecie) as any[]).reduce((acc, curr) => {
            const key = `${curr.diametro || 0}`;
            if (!acc[key]) { acc[key] = []; }
            acc[key].push({
                "Specie": specieArboree.find(f => f.id === curr.specie)?.label || '',
                "Contatore":  curr.contatore || curr.contatore==0 ?  curr.contatore : '',
            })
            return acc;
        }, {});


        printObj.push({
            header: `Rilievi cavallettamenti (per diametro)`,
            data: classiDiametricheReduceByDiametro
        })
    }

    const pianteCampione = (await areaSaggioPiantaCampioneStore.getters.getAll()).filter(f => f.areaSaggioId === source.id);
    if (pianteCampione && pianteCampione.length > 0) {
        const pianteCampioneReduced = {};
        for (let index = 0; index < pianteCampione.length; index++) {
            const pianta = pianteCampione[index];

            pianteCampioneReduced[`${(index + 1)}`]=[];
        
            pianteCampioneReduced[`${(index + 1)}`].push({
                'Specie': specieArboree.find(f => f.id === pianta.specie)?.label || '',
            });
            pianteCampioneReduced[`${(index + 1)}`].push({
                'Diametro': pianta.diametro || pianta.diametro==0  ? pianta.diametro.toFixed(1) + ' cm' : '',
            });
            pianteCampioneReduced[`${(index + 1)}`].push({
                'Diametro metà altezza': pianta.diametroMetaAltezza || pianta.diametroMetaAltezza==0 ? pianta.diametroMetaAltezza.toFixed(1) + ' cm' : '',
            });
            pianteCampioneReduced[`${(index + 1)}`].push({
                'Altezza': pianta.altezza || pianta.altezza==0 ? pianta.altezza.toFixed(1) + ' m' : '',
            });
            if(pianta.note){
                pianteCampioneReduced[`${(index + 1)}`].push({
                    'Note' :  pianta.note,
                });
            }
                     
        }
        printObj.push({ header: `Rilievi ipsometrici`, data: pianteCampioneReduced });
    }

    printerHelper.print(type, source.nome, 'Area di Saggio', printObj);
}